import { Component } from '@verndale/core';
import { gsap } from 'gsap';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      arrowLine: this.el.querySelector('#arrow-line'),
      arrowBottom: this.el.querySelector('#arrow-bottom'),
      videoElement: this.el.querySelector('video'),
      playPauseBtn: this.el.querySelector('.video-player__play-pause-btn'),
      playIcon: this.el.querySelector('.cta-decorator-v2--video-play'),
      pauseIcon: this.el.querySelector('.cta-decorator-v2--video-pause')
    };

    this.videoSource = this.el.dataset.videoSource;
    this.dom.videoElement.src = this.videoSource;
    this.dom.playIcon.style.display = 'none';


    if (this.dom.arrowLine) {
      this.animateLine();
    }

    if (this.dom.arrowBottom) {
      this.animateArrow();
    }


  }


  addListeners() {
    this.dom.playPauseBtn.addEventListener(
      'click',
      this.handlePlayPauseBtn.bind(this)
    );
  }

  handlePlayPauseBtn() {

    if (this.dom.videoElement.paused) this.playVideo();
    else this.pauseVideo();

  }

  playVideo() {
    this.dom.videoElement.play();
    this.dom.playIcon.style.display = 'none';
    this.dom.pauseIcon.style.display = 'inline-flex';
  }

  pauseVideo() {
    this.dom.videoElement.pause();
    this.dom.pauseIcon.style.display = 'none';
    this.dom.playIcon.style.display = 'inline-flex';
  }



  animateLine() {
    gsap.to(this.dom.arrowLine, {
      keyframes: [
        { y:90, duration: 1.5, ease: 'expo.out', transform: 'scaleY(1)', transformOrigin: 'top'  },
        { y:175, duration: 1, ease: 'expo.in', transform: 'scaleY(0)', transformOrigin: 'bottom' }
      ],
      repeat: 2,
      onComplete: this.stopLine.bind(this)
    });
  }
  animateArrow() {
    gsap.to(this.dom.arrowBottom, {
      keyframes: [
        { y:80, duration: 1.5, ease: 'expo.out' },
        { y:120, duration: 1, ease: 'expo.in' }
      ],
      repeat: 2,
      onComplete: this.stopArrow.bind(this)
    });
  }
  stopLine() {
    gsap.fromTo(this.dom.arrowLine,
      {
        transform: 'scaleY(1)',
        transformOrigin: 'top',
        y:5
      },
      {
        transform: 'scaleY(1)',
        transformOrigin: 'top',
        y: 87,
        duration:2,
        repeat:0,
        ease: 'slow (0.1, 1, false)'
      });
  }
  stopArrow() {
    gsap.fromTo(this.dom.arrowBottom,
      {
        y:0
      },
      {
        y: 83,
        duration:2,
        repeat:0,
        ease: 'slow (0.1, 1, false)'
      });
  }





}
export default Module;
